import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { GroupParagraph } from '../models/group-paragraph';
import { createGroupParagraphEndpoint } from './const';

export const createGroupParagraph = (groupParagraph: GroupParagraph) => {
    return getHttpClient().post({ url: createGroupParagraphEndpoint, data: JSON.stringify(groupParagraph) });
};
